{
	"dist_folder": "public",
	"static_folder": "static",
	"repo_name": "interactive-media-design-day",
	"preview_document_id_cookie": "io.prismic.preview.documentId",
	"domain": "https://www.imdsg.ch"
}
